import React from "react"
import moment from "moment"
import clsx from "clsx"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import { CandidatureModel } from "@common-models/*"
import { CONST_CANDIDAT_TYPE_POSTULANT, CONST_CANDIDAT_TYPE_CS, CONST_CANDIDAT_TYPE_SAISI } from "@common-constants/*"

interface Props {
     candidat: any
     candidatures: CandidatureModel[]
     isLoadingCandidatures: boolean
     helpers: any
}

export const InterviewContext: React.FC<Props> = ({ candidat, candidatures, isLoadingCandidatures, helpers }) => {
     return (
          <div className="rounded border border-dashed border-gray-300 p-6 bg-light-secondary bg-opacity-20 mb-8">
               <label className="fs-7 fw-boldest text-uppercase mb-3 text-gray-600 d-block">Contexte du candidat</label>

               {candidat.type === CONST_CANDIDAT_TYPE_POSTULANT && (
                    <div className="d-flex flex-column gap-2">
                         <span className="fs-8 fw-bold text-gray-500">
                              Le candidat a postulé à {candidatures.length} {candidatures.length > 1 ? "offres" : "offre"}.
                         </span>
                         {isLoadingCandidatures ? (
                              <div className="py-2">
                                   <MySimpleSpinner size="sm" />
                              </div>
                         ) : (
                              <select
                                   className={clsx("form-select form-select-sm form-select-solid", helpers.errors.annonce && helpers.touched.annonce && "is-invalid")}
                                   value={helpers.values.annonce}
                                   onChange={e => helpers.setFieldValue("annonce", e.target.value)}
                              >
                                   <option value="">Sélectionner l'offre concernée...</option>
                                   {candidatures.map(c => (
                                        <option key={c.annonce?.id} value={c.annonce?.id}>
                                             {c.annonce?.intitule || "Sans titre"} — {moment(c.date).format("DD/MM/YYYY")}
                                        </option>
                                   ))}
                              </select>
                         )}
                         {helpers.errors.annonce && helpers.touched.annonce && <div className="text-danger fs-8 mt-1">{helpers.errors.annonce as string}</div>}
                    </div>
               )}

               {candidat.type === CONST_CANDIDAT_TYPE_CS && (
                    <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed p-3">
                         <i className="fas fa-info-circle text-primary fs-4 me-3"></i>
                         <div className="fs-7 fw-bold text-primary">Le candidat a postulé en candidature spontanée.</div>
                    </div>
               )}

               {candidat.type === CONST_CANDIDAT_TYPE_SAISI && (
                    <div className="notice d-flex bg-light-info rounded border-info border border-dashed p-3">
                         <i className="fas fa-user-edit text-info fs-4 me-3"></i>
                         <div className="fs-7 fw-bold text-info">Le candidat a été ajouté manuellement par le staff.</div>
                    </div>
               )}
          </div>
     )
}
